import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

/**
 * Hook to get fielding groups for the current project
 */
const useGetFieldingGroups = () => {
  const projectId = useGetCurrentProjectId();

  return projectApi.useGetProjectsByProjectIdFieldingGroupQuery(
    { projectId: projectId ?? 0, expand: true },
    { skip: !projectId },
  );
};

export default useGetFieldingGroups;
